<div class="px-2">
  <div *ngIf="modifier" [ngSwitch]="modifier.type">

    <div *ngSwitchCase="'styleByThresholds'">
      <div class="flex flex-column mt-2">
        <div class="flex justify-content-between">
          <div class="flex gap-3">
            <button
              [label]="'misc.addThreshold' | transloco"
              (click)="addThreshold(modifier.args.thresholds)"
              pButton
              icon="pi pi-plus"
            ></button>
            <button
              *ngIf="!modifier.args.defaultStyle"
              [label]="'misc.addDefaultStyle' | transloco"
              (click)="addDefaultThreshold(modifier.args)"
              pButton
              icon="pi pi-plus"
            ></button>
            <button
              *ngIf="modifier.args.defaultStyle"
              [label]="'misc.removeDefaultStyle' | transloco"
              (click)="removeDefaultThreshold(modifier.args)"
              pButton
              icon="pi pi-trash"
            ></button>
          </div>
          <p-multiSelect
            [(ngModel)]="modifier.args.attributes"
            [options]="availableThresholdAttributes | translateLabels | async"
            [showHeader]="false"
            [placeholder]="'select.attributes' | transloco"
            optionValue="value"
            appendTo="body"
          ></p-multiSelect>
        </div>
        <div
          *ngIf="modifier.args.attributes.includes('widthPercentage') || modifier.args.attributes.includes('heightPercentage')"
          class="mt-3 flex flex-column"
        >
          <label class="mb-2">{{'attribute.anchor' | transloco}}</label>
          <app-anchor-selector
            [(anchor)]="modifier.args.originAnchor"
            [showHorizontal]="modifier.args.attributes.includes('widthPercentage')"
            [showVertical]="modifier.args.attributes.includes('heightPercentage')"
          ></app-anchor-selector>
        </div>
        <div *ngIf="modifier.args.defaultStyle" class="flex flex-column threshold-card mt-3 p-3 px-4">
          <label class="font-bold">
            {{'common.default' | transloco}}
          </label>
          <ng-container
            [ngTemplateOutlet]="styleTemplate"
            [ngTemplateOutletContext]="{ style: modifier.args.defaultStyle }"
          ></ng-container>
        </div>
        <div *ngFor="let threshold of modifier.args.thresholds" class="flex threshold-card mt-3">
          <div class="flex flex-column flex-grow-1 p-3 px-4">
            <div class="flex mb-2 gap-3">
              <div class="flex flex-column w-6">
                <label class="mb-2">{{'common.from' | transloco}}</label>
                <p-inputNumber
                  [(ngModel)]="threshold.from"
                  [minFractionDigits]="2"
                  mode="decimal"
                  locale="en-US"
                  styleClass="w-full"
                ></p-inputNumber>
              </div>
              <div class="flex flex-column w-6">
                <label class="mb-2">{{'common.to' | transloco}}</label>
                <p-inputNumber
                  [(ngModel)]="threshold.to"
                  [minFractionDigits]="2"
                  mode="decimal"
                  locale="en-US"
                  styleClass="w-full"
                ></p-inputNumber>
              </div>
            </div>
            <ng-container
              [ngTemplateOutlet]="styleTemplate"
              [ngTemplateOutletContext]="{ style: threshold }"
            ></ng-container>
          </div>
          <div class="flex justify-content-center align-items-center bg-gray-100 p-3">
            <button
              (click)="removeThreshold(threshold, modifier.args)"
              pButton
              class="p-button-text p-button-icon-only text-gray-600"
              icon="pi pi-trash"
            ></button>
          </div>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="'styleByContinuousValue'">
      <div class="flex flex-column mb-2">
        <div class="flex justify-content-between">
          <p-multiSelect
            [(ngModel)]="modifier.args.attributes"
            [options]="availableContinuousAttributes | translateLabels | async"
            [showHeader]="false"
            [placeholder]="'select.attributes' | transloco"
            optionValue="value"
            appendTo="body"
          ></p-multiSelect>
        </div>
        <div
          *ngIf="modifier.args.attributes.includes('widthPercentage') || modifier.args.attributes.includes('heightPercentage')"
          class="mt-3 flex flex-column"
        >
          <label class="mb-2">{{'attribute.anchor' | transloco}}</label>
          <app-anchor-selector
            [(anchor)]="modifier.args.originAnchor"
            [showHorizontal]="modifier.args.attributes.includes('widthPercentage')"
            [showVertical]="modifier.args.attributes.includes('heightPercentage')"
          ></app-anchor-selector>
        </div>
        <div class="flex my-2 gap-3">
          <div class="flex flex-column w-6">
            <label class="mb-2">{{'common.from' | transloco}}</label>
            <p-inputNumber
              [(ngModel)]="modifier.args.valueRange[0]"
              [minFractionDigits]="2"
              mode="decimal"
              locale="en-US"
              styleClass="w-full"
            ></p-inputNumber>
          </div>
          <div class="flex flex-column w-6">
            <label class="mb-2">{{'common.to' | transloco}}</label>
            <p-inputNumber
              [(ngModel)]="modifier.args.valueRange[1]"
              [minFractionDigits]="2"
              mode="decimal"
              locale="en-US"
              styleClass="w-full"
            ></p-inputNumber>
          </div>
        </div>
        <div *ngIf="modifier.args.attributes.includes('backgroundColor')" class="flex flex-column mt-2">
          <label class="mb-2">{{'attribute.backgroundColor' | transloco}}</label>
          <div class="flex gap-3 justify-content-between">
            <div class="flex flex-column flex-grow-1">
              <label class="mb-2">{{'common.from' | transloco}}</label>
              <app-color-picker [(color)]="modifier.args.backgroundColorRange[0]"></app-color-picker>
            </div>
            <div class="flex flex-column flex-grow-1">
              <label class="mb-2">{{'common.to' | transloco}}</label>
              <app-color-picker [(color)]="modifier.args.backgroundColorRange[1]"></app-color-picker>
            </div>
          </div>
        </div>
        <div *ngIf="modifier.args.attributes.includes('widthPercentage')" class="flex flex-column mt-2">
          <label class="mb-2">{{'attribute.widthPercentage' | transloco}}</label>
          <div class="flex gap-3 justify-content-between">
            <div class="flex flex-column flex-grow-1">
              <label class="mb-2">{{'common.from' | transloco}}</label>
              <p-inputNumber
                [(ngModel)]="modifier.args.widthPercentageRange[0]"
                [suffix]="'%'"
                [min]="0"
                [max]="100"
                mode="decimal"
                styleClass="w-full"
              ></p-inputNumber>
              <p-slider [(ngModel)]="modifier.args.widthPercentageRange[0]" [min]="0" [max]="100"></p-slider>
            </div>
            <div class="flex flex-column flex-grow-1">
              <label class="mb-2">{{'common.to' | transloco}}</label>
              <p-inputNumber
                [(ngModel)]="modifier.args.widthPercentageRange[1]"
                [suffix]="'%'"
                [min]="0"
                [max]="100"
                mode="decimal"
                styleClass="w-full"
              ></p-inputNumber>
              <p-slider [(ngModel)]="modifier.args.widthPercentageRange[1]" [min]="0" [max]="100"></p-slider>
            </div>
          </div>
        </div>
        <div *ngIf="modifier.args.attributes.includes('heightPercentage')" class="flex flex-column mt-2">
          <label class="mb-2">{{'attribute.heightPercentage' | transloco}}</label>
          <div class="flex gap-3 justify-content-between">
            <div class="flex flex-column flex-grow-1">
              <label class="mb-2">{{'common.from' | transloco}}</label>
              <p-inputNumber
                [(ngModel)]="modifier.args.heightPercentageRange[0]"
                [suffix]="'%'"
                [min]="0"
                [max]="100"
                [minFractionDigits]="2"
                mode="decimal"
                locale="en-US"
                styleClass="w-full"
              ></p-inputNumber>
              <p-slider [(ngModel)]="modifier.args.heightPercentageRange[0]" [min]="0" [max]="100"></p-slider>
            </div>
            <div class="flex flex-column flex-grow-1">
              <label class="mb-2">{{'common.to' | transloco}}</label>
              <p-inputNumber
                [(ngModel)]="modifier.args.heightPercentageRange[1]"
                [suffix]="'%'"
                [min]="0"
                [max]="100"
                [minFractionDigits]="2"
                mode="decimal"
                locale="en-US"
                styleClass="w-full"
              ></p-inputNumber>
              <p-slider [(ngModel)]="modifier.args.heightPercentageRange[1]" [min]="0" [max]="100"></p-slider>
            </div>
          </div>
        </div>
        <div *ngIf="modifier.args.attributes.includes('opacityPercentage')" class="flex flex-column mt-2">
          <label class="mb-2">{{'attribute.opacityPercentage' | transloco}}</label>
          <div class="flex gap-3 justify-content-between">
            <div class="flex flex-column flex-grow-1">
              <label class="mb-2">{{'common.from' | transloco}}</label>
              <p-inputNumber
                [(ngModel)]="modifier.args.opacityPercentageRange[0]"
                [suffix]="'%'"
                [min]="0"
                [max]="100"
                [minFractionDigits]="2"
                mode="decimal"
                locale="en-US"
                styleClass="w-full"
              ></p-inputNumber>
              <p-slider [(ngModel)]="modifier.args.opacityPercentageRange[0]" [min]="0" [max]="100"></p-slider>
            </div>
            <div class="flex flex-column flex-grow-1">
              <label class="mb-2">{{'common.to' | transloco}}</label>
              <p-inputNumber
                [(ngModel)]="modifier.args.opacityPercentageRange[1]"
                [suffix]="'%'"
                [min]="0"
                [max]="100"
                [minFractionDigits]="2"
                mode="decimal"
                locale="en-US"
                styleClass="w-full"
              ></p-inputNumber>
              <p-slider [(ngModel)]="modifier.args.opacityPercentageRange[1]" [min]="0" [max]="100"></p-slider>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="'replaceTextValue'" class="flex flex-column">
      <label class="mt-3 mb-2">{{'attribute.decimalPlaces' | transloco}}</label>
      <p-inputNumber
        [(ngModel)]="modifier.args.decimalPlaces"
        [min]="0"
        [max]="16"
        styleClass="w-full"
      ></p-inputNumber>
      <div class="flex gap-3">
        <div class="flex flex-column w-6">
          <label class="mt-3 mb-2">{{'attribute.conversionOperation' | transloco}}</label>
          <p-dropdown
            [(ngModel)]="modifier.args.conversionFactorOperation"
            [options]="conversionFactorOptions | translateLabels | async"
            [placeholder]="'empty.conversionFactor' | transloco"
            [showClear]="true"
            styleClass="w-full"
          ></p-dropdown>
        </div>
        <div class="flex flex-column w-6">
          <label class="mt-3 mb-2">{{'attribute.conversionFactor' | transloco}}</label>
          <p-inputNumber
            [(ngModel)]="modifier.args.conversionFactor"
            [disabled]="!modifier.args.conversionFactorOperation"
            [minFractionDigits]="2"
            mode="decimal"
            locale="en-US"
            styleClass="w-full"
          ></p-inputNumber>
        </div>
      </div>
      <label class="mt-3 mb-2">{{'attribute.showUnits' | transloco}}</label>
      <p-checkbox
        [(ngModel)]="modifier.args.showUnits"
        [binary]="true"
      ></p-checkbox>
    </div>

  </div>

  <div class="mt-4 flex justify-content-between">
    <button
      [label]="'common.cancel' | transloco"
      (click)="ref.close(null)"
      pButton
      class="p-button-danger"
    ></button>
    <button
      [label]="'common.save' | transloco"
      (click)="ref.close(modifier)"
      pButton
    ></button>
  </div>
</div>

<ng-template let-style="style" #styleTemplate>
  <div *ngIf="modifier.args.attributes.includes('backgroundColor')" class="flex flex-column mb-2">
    <label class="mt-3 mb-2">{{'attribute.backgroundColor' | transloco}}</label>
    <app-color-picker [(color)]="style.backgroundColor"></app-color-picker>
  </div>
  <div
    *ngIf="modifier.args.attributes.includes('widthPercentage') ||
                  modifier.args.attributes.includes('heightPercentage')"
    class="flex justify-content-between my-2 gap-3"
  >
    <div *ngIf="modifier.args.attributes.includes('widthPercentage')"
         class="flex flex-column flex-grow-1">
      <label class="mb-2">{{'attribute.widthPercentage' | transloco}}</label>
      <p-inputNumber
        [(ngModel)]="style.widthPercentage"
        [suffix]="'%'"
        [min]="0"
        [max]="100"
        styleClass="w-full"
      ></p-inputNumber>
      <p-slider [(ngModel)]="style.widthPercentage" [min]="0" [max]="100"></p-slider>
    </div>
    <div *ngIf="modifier.args.attributes.includes('heightPercentage')"
         class="flex flex-column flex-grow-1">
      <label class="mb-2">{{'attribute.heightPercentage' | transloco}}</label>
      <p-inputNumber
        [(ngModel)]="style.heightPercentage"
        [suffix]="'%'"
        [min]="0"
        [max]="100"
        styleClass="w-full"
      ></p-inputNumber>
      <p-slider [(ngModel)]="style.heightPercentage" [min]="0" [max]="100"></p-slider>
    </div>
  </div>
  <div *ngIf="modifier.args.attributes.includes('visibility')" class="flex my-2 py-2 gap-4">
    <div class="flex flex-column">
      <label class="mb-2">{{'attribute.visible' | transloco}}</label>
      <div class="flex-grow-1 w-full">
        <div class="flex h-full justify-content-center align-items-center">
          <button
            [icon]="style['visible'] ? 'pi pi-eye' : 'pi pi-eye-slash'"
            [ngClass]="{ 'p-button-secondary': !style['visible'] }"
            (click)="style['visible'] = !style['visible']"
            pButton
            class="p-button-icon-only p-button-rounded"
          ></button>
        </div>
      </div>
    </div>
    <div class="flex flex-column flex-grow-1">
      <label class="mb-2">{{'attribute.opacityPercentage' | transloco}}</label>
      <p-inputNumber
        [(ngModel)]="style.opacityPercentage"
        [disabled]="!style.visible"
        [suffix]="'%'"
        [min]="0"
        [max]="100"
        mode="decimal"
        styleClass="w-full"
      ></p-inputNumber>
      <p-slider
        [(ngModel)]="style.opacityPercentage"
        [disabled]="!style.visible"
        [min]="0"
        [max]="100"
      ></p-slider>
    </div>
  </div>
</ng-template>
